import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CameraHealthTimeSeriesResult, GetCameraTimeSeriesRequest, ListCamerasRequest, ListCamerasResponse } from '../types';

@Injectable({
  providedIn: 'root',
})
export class CameraHealthService {
  apiHost = `${environment.apiBaseUrl}`;

  private httpClient = inject(HttpClient);

  listCameras(dto: ListCamerasRequest): Observable<ListCamerasResponse> {
    const requestUrl = `${this.apiHost}/Branches/${dto.branch}/Cameras`;
    const params = this.getListCameraHealthParams(dto);
    return this.httpClient.get<ListCamerasResponse>(requestUrl, { params });
  }

  getCameraHealthTimeSeries(dto: GetCameraTimeSeriesRequest): Observable<CameraHealthTimeSeriesResult> {
    const requestUrl = `${this.apiHost}/Branches/${dto.branch}/Cameras/TimeSeries`;
    // I'm not actually using the list camera health params, but I might need to in case requirements change.
    let params = this.getListCameraHealthParams(dto);
    if (dto.anchorDate) params = params.append('anchor_date', dto.anchorDate.toISOString());
    return this.httpClient.get<CameraHealthTimeSeriesResult>(requestUrl, { params });
  }

  private getListCameraHealthParams(dto: ListCamerasRequest) {
    let params = new HttpParams();
    if (dto.search) params = params.append('search', dto.search);
    if (dto.itemsPerPage) params = params.append('items_per_page', dto.itemsPerPage.toString());
    if (!isNaN(dto.page)) params = params.append('page', dto.page.toString());
    if (dto.sort) params = params.append('sort', dto.sort);
    if (dto.sortDirection) params = params.append('sort_direction', dto.sortDirection);
    return params;
  }
}
